<template>
  <div class="appoint-title">
    <span class="appoint-title-content">
      <span class="appoint-title-required">{{isCheck?'*':' '}}</span>
      {{ title }}
    </span>

    <!-- <button
      class="appoint-title-button"
      v-if="buttonContent != ''"
      @click="onClick"
    >
      {{ buttonContent }}
    </button> -->
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    isCheck: {
      type: Boolean,
      default: false
    },
    buttonContent: {
      type: String,
      default: ''
    },
    buttonKey: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  watch: {},
  computed: {},
  methods: {
    onClick() {
      this.$emit('titleClick', {buttonKey: this.buttonKey})
    }
  },
  created() {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
.appoint-title {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 10px;
  display: flex;
  flex: 1;
  .appoint-title-content {
    flex: 1;
    .appoint-title-required {
      font-size: 14px;
      font-weight: 500;
      color: #fa6366;
      padding-right: 3px;
    }
  }
  .appoint-title-button {
    color: #1989fa;
    background-color: #fff;
    border: 1px solid #1989fa;
  }
}
</style>
